// src/data/matches.js (modified - only ISO format)
export const matchesData = [
  {
    id: "mu-vs-liverpool",
    matchId: 1,
    homeTeam: {
      name: "Manchester United",
      logo: "MU"
    },
    awayTeam: {
      name: "Liverpool",
      logo: "LIV"
    },
    league: "Premier League",
    dateISO: "2026-03-01T11:15:00.000Z", // Waktu kickoff dalam UTC (19:00 WIB = 12:00 UTC)
    venue: "Old Trafford",
    tvChannel: "SCTV, Vidio",
    status: "live",
    score: {
      home: 2,
      away: 1
    },
    isBigMatch: true,
    // Jadwal muncul dan hilang dalam ISO format (UTC)
    showStart: "2026-03-01T10:00:00.000Z", // Muncul jam 10:00 UTC (17:00 WIB)
    showEnd: "2026-03-01T21:00:00.000Z"    // Hilang jam 21:00 UTC (04:00 WIB next day)
  },
  {
    id: "real-madrid-vs-barcelona",
    matchId: 2,
    homeTeam: {
      name: "Real Madrid",
      logo: "RM"
    },
    awayTeam: {
      name: "Barcelona",
      logo: "BAR"
    },
    league: "La Liga",
    dateISO: "2026-03-01T14:00:00.000Z", // 21:00 WIB = 14:00 UTC
    venue: "Santiago Bernabeu",
    tvChannel: "beIN Sports",
    status: "upcoming",
    score: {
      home: 0,
      away: 0
    },
    isBigMatch: true,
    showStart: "2026-03-01T11:00:00.000Z", // Muncul jam 12:00 UTC (19:00 WIB)
    showEnd: "2026-03-01T23:00:00.000Z"    // Hilang jam 23:00 UTC (06:00 WIB next day)
  },
  {
    id: "bayern-vs-dortmund",
    matchId: 3,
    homeTeam: {
      name: "Bayern Munich",
      logo: "BAY"
    },
    awayTeam: {
      name: "Borussia Dortmund",
      logo: "BVB"
    },
    league: "Bundesliga",
    dateISO: "2026-02-13T13:00:00.000Z", // 20:00 WIB = 13:00 UTC
    venue: "Allianz Arena",
    tvChannel: "Mola TV",
    status: "finished",
    score: {
      home: 4,
      away: 0
    },
    isBigMatch: true,
    showStart: "2026-02-13T11:00:00.000Z", // Muncul jam 11:00 UTC (18:00 WIB)
    showEnd: "2026-02-13T22:00:00.000Z"    // Hilang jam 22:00 UTC (05:00 WIB next day)
  },
  {
    id: "juventus-vs-ac-milan",
    matchId: 4,
    homeTeam: {
      name: "Juventus",
      logo: "JUV"
    },
    awayTeam: {
      name: "AC Milan",
      logo: "ACM"
    },
    league: "Serie A",
    dateISO: "2026-02-13T10:30:00.000Z", // 17:30 WIB = 10:30 UTC
    venue: "Allianz Stadium",
    tvChannel: "RCTI+",
    status: "upcoming",
    score: {
      home: 0,
      away: 0
    },
    isBigMatch: false,
    showStart: "2026-02-13T08:30:00.000Z", // Muncul jam 08:30 UTC (15:30 WIB)
    showEnd: "2026-02-13T19:30:00.000Z"    // Hilang jam 19:30 UTC (02:30 WIB next day)
  },
  {
    id: "psg-vs-marseille",
    matchId: 5,
    homeTeam: {
      name: "PSG",
      logo: "PSG"
    },
    awayTeam: {
      name: "Marseille",
      logo: "OM"
    },
    league: "Ligue 1",
    dateISO: "2026-02-13T15:00:00.000Z", // 22:00 WIB = 15:00 UTC
    venue: "Parc des Princes",
    tvChannel: "beIN Sports",
    status: "live",
    score: {
      home: 1,
      away: 0
    },
    isBigMatch: false,
    showStart: "2026-02-13T13:00:00.000Z", // Muncul jam 13:00 UTC (20:00 WIB)
    showEnd: "2026-02-14T00:00:00.000Z"    // Hilang jam 00:00 UTC (07:00 WIB next day)
  },
  {
    id: "arsenal-vs-chelsea",
    matchId: 6,
    homeTeam: {
      name: "Arsenal",
      logo: "ARS"
    },
    awayTeam: {
      name: "Chelsea",
      logo: "CHE"
    },
    league: "Premier League",
    dateISO: "2026-02-13T11:00:00.000Z", // 18:00 WIB = 11:00 UTC
    venue: "Emirates Stadium",
    tvChannel: "Vidio",
    status: "upcoming",
    score: {
      home: 0,
      away: 0
    },
    isBigMatch: true,
    showStart: "2026-02-13T09:00:00.000Z", // Muncul jam 09:00 UTC (16:00 WIB)
    showEnd: "2026-02-13T20:00:00.000Z"    // Hilang jam 20:00 UTC (03:00 WIB next day)
  }
];
